import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit,
  AfterViewChecked,
} from "@angular/core";
import { InteraccionMapaService } from "src/app/services/interaccion-mapa.service";
import { Observable } from "rxjs";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { take } from "rxjs/operators";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { Router } from "@angular/router";
import { LoaderService } from "src/app/services/loader.service";
import { EstadoRouteService } from "src/app/services/estado-route.service";

@Component({
  selector: "layout-header",
  templateUrl: "./layout-header.component.html",
  styleUrls: ["./layout-header.component.scss"],
})
export class LayoutHeaderComponent implements OnInit, AfterViewChecked {
  public mostrarBreadcrumb$: Observable<boolean> = null;
  public mostrarPanelBusquedas$: Observable<boolean> = null;
  public usuario$: Observable<UsuarioSesionDTO> = null;
  public direccion$: Observable<string> = null;
  public tipoObra$: Observable<string> = null;
  public funcionalidad$: Observable<string> = null;
  public mostrarPanelBusqueda: boolean = false;
  public coincidenciaObrasProceso: LevantamientoObra[];
  public coincidenciaObrasPlaneacion: LevantamientoObra[];

  public mostrarBtnRetroceder$: Observable<boolean>;
  public mostrarBtnRegresarDetalleObra$: Observable<boolean>;
  public detalleObraProceso$: Observable<boolean>;
  public mostrarBtnCatalogos$: Observable<boolean>;
  public catalogos$: Observable<boolean>;

  constructor(
    private interaccionMapaService: InteraccionMapaService,
    private facadeSesionService: FacadeSesionService,
    private cd: ChangeDetectorRef,
    private levantamientoObraService: LevantamientoObraService,
    private router: Router,
    private loaderService: LoaderService,
    private estadoRouteService: EstadoRouteService
  ) {}

  ngOnInit() {
    this.mostrarBtnRetroceder$ = this.estadoRouteService.mostrarBtnRetroceder$.asObservable();
    this.mostrarBtnRegresarDetalleObra$ = this.estadoRouteService.mostrarBtnRegresarDetalleObra$.asObservable();
    this.detalleObraProceso$ = this.estadoRouteService.detalleObraProceso$.asObservable();
    this.mostrarBtnCatalogos$ = this.estadoRouteService.mostrarBtnCatalogos$.asObservable();
    this.catalogos$ = this.estadoRouteService.catalogos$.asObservable();
    this.usuario$ = this.facadeSesionService.usuarioEnSesionService.obtenerUsuario();
    this.direccion$ = this.facadeSesionService.breadcrumbService.obtenerBreadcrumbDireccion();
    this.tipoObra$ = this.facadeSesionService.breadcrumbService.obtenerBreadcrumbTipoObra();
    this.funcionalidad$ = this.facadeSesionService.breadcrumbService.obtenerBreadcrumbFuncionalidad();
    this.mostrarBreadcrumb$ = this.facadeSesionService.interfazService.obtenerBreadcrumb();
    this.mostrarPanelBusquedas$ = this.facadeSesionService.interfazService.obtenerPanelBusquedas();
  }
  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  public busquedaObras(value: string) {
    this.mostrarPanelBusqueda = false;
    if (value) {
      this.consultaObras(value);
      this.mostrarPanelBusqueda = true;
    }
  }

  public async consultaObras(obraBuscada: string) {
    this.coincidenciaObrasProceso = [];
    this.coincidenciaObrasPlaneacion = [];
    let obras: LevantamientoObra[] = await this.levantamientoObraService
      .findAprobados()
      .pipe(take(1))
      .toPromise();
    for (let i = 0; i < obras.length; i++) {
      if (
        obras[i].nombreObra.toUpperCase().indexOf(obraBuscada.toUpperCase()) >
        -1
      ) {
        if (obras[i].keyCatTipoObra === "0") {
          this.coincidenciaObrasProceso.push(obras[i]);
        } else {
          this.coincidenciaObrasPlaneacion.push(obras[i]);
        }
      }
    }
  }

  public abrirDetalleObra(obraSeleccionada: LevantamientoObra) {
    this.interaccionMapaService.establecerDatosObra(obraSeleccionada);
    this.mostrarPanelBusqueda = false;
    this.router.navigate(["/tablero/detalle-obra"], {
      skipLocationChange: true,
    });
    this.loaderService.activarLoaderScreen();
  }

  public retroceder() {
    this.estadoRouteService.retroceder();
  }

  public retrocederObrasProceso() {
    this.estadoRouteService.mostrarBtnRetroceder$.next(true);
    this.estadoRouteService.mostrarBtnRegresarDetalleObra$.next(false);
    this.estadoRouteService.detalleObraProceso$.next(false);
  }

  public retrocederCatalogos() {
    this.estadoRouteService.mostrarBtnRetroceder$.next(true);
    this.estadoRouteService.mostrarBtnCatalogos$.next(false);
    this.estadoRouteService.catalogos$.next(false);
  }

  public avanzar() {
    // this.estadoRouteService
  }

  public cerrarBusqueda() {
    this.mostrarPanelBusqueda = false;
  }
}
